// extracted by mini-css-extract-plugin
export default {"selectConversation":"rQ8sO","icon":"FKfif"};